import { FunctionComponent, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";

import { BouncingDots } from "../../../components/Shared/LoadingSkeletons/BouncingDots/BouncingDots";
import { IChatThreadExtendedModel } from "../../../models/interfaces";
import { useThreadService } from "../../../services/ServiceHooks";
import { useStore } from "../../../stores/StoreContext";
import { ThreadHistoryList } from "./ThreadHistoryList/ThreadHistoryList";

const RawChatThreadHistory: FunctionComponent = () => {
  const { threadStore, chatStore } = useStore();

  const [isLoadingThreads, setIsLoadingThreads] = useState(true);
  const [isLoadingKnowledgeBases, setIsLoadingKnowledgeBases] = useState(true);
  const threadService = useThreadService();

  const [threads, setThreads] = useState<IChatThreadExtendedModel[]>([]);

  useEffect(() => {
    setIsLoadingThreads(false);

    const loadThreads = async () => {
      setIsLoadingThreads(true);
      await threadService.loadThreads();
      setIsLoadingThreads(false);
    };

    if (!threadStore.threads?.length) {
      loadThreads();
    }
  }, []);

  useEffect(() => {
    setIsLoadingThreads(true);

    setTimeout(() => {
      // Delay setting threads to improve UI Render performance during expanding process of sidebar
      setThreads(threadStore.threads);
      setIsLoadingThreads(false);
    }, 300);
  }, [threadStore.threads]);

  useEffect(() => {
    setIsLoadingKnowledgeBases(chatStore.isKnowledgeBaseSelectionLoading);
  }, [chatStore.isKnowledgeBaseSelectionLoading]);

  if (isLoadingThreads || isLoadingKnowledgeBases) {
    return <BouncingDots />;
  }

  return (
    <ThreadHistoryList
      threads={threads}
      knowledgeBases={chatStore.knowledgeBases}
      activeThreadId={threadStore.activeThread?.id}
      showDateSeparators={true}
    />
  );
};

export const ChatThreadHistory = observer(RawChatThreadHistory);
